// REACT IMPORTS
import React, { useState, useEffect } from "react";

// CONTROLS IMPORTS
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { esES, enUS } from '@mui/x-data-grid/locales';
import { Box, TextField, Menu, MenuItem, Divider, IconButton, Grid,
    FormControl, InputLabel, Select, Typography, Button, Checkbox
 } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import Rating from '@mui/material/Rating';

// ICONS IMPORTS
import VisibilityIcon from '@mui/icons-material/Visibility';

// REDUX IMPORTS
import { useDispatch, useSelector } from 'react-redux';
import { load, remove } from '../../store/thunks';
import { selectItem, showUserViewProfile } from '../../store/slices';

// LANGUAGE IMPORTS
import { useTranslation } from 'react-i18next';

// OWNED COMPONENTS IMPORTS
import { constants } from  '../../util'
import UsersViewProfile from "./usersViewProfile";
import BodyMain from "../../components/util/BodyMain";



const UsersView = () => {
    // TRANSLATIONS
    const [t, i18n] = useTranslation("global");


    // LOCAL VARIABLES
    const active = 'true';
    const roleId = 3;

    const columsGrid = 
    [
        {
            field: 'userId',
            description: t("userView.columnView"),
            headerName: t("userView.columnView"),
            type: 'string',
            width: 80,
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%', height:'100%',
                            display:'flex',
                            justifyContent:'center',
                            alignContent:'center'
                            }}
                    >
                        <div>
                            <IconButton 
                                color="primary"
                                onClick={(e) => handleClickMenu(params.value)}
                                aria-label="menu"
                            >
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'name',
            description: t("userView.name"),
            headerName: t("userView.name"),
            type: 'string',
            width: 200,
            headerAlign: 'left',
        },
        {
            field: 'email',
            description: t("userView.email"),
            headerName: t("userView.email"),
            type: 'string',
            width: 300,
            headerAlign: 'left',
        },
        {
            field: 'grade',
            description: t("userView.grade"),
            headerName: t("userView.grade"),
            type: 'string',
            width: 120,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <Rating value={params.value} size="small" max={5} readOnly />
                );
            }
        },
        // {
        //     field: 'roleName',
        //     description: t("userView.role"),
        //     headerName: t("userView.role"),
        //     type: 'string',
        //     width: 130,
        //     headerAlign: 'left',
        //     renderCell: (params) => {
        //         return (
        //             <div>
        //                 {
        //                     params.value==='Administrador'
        //                         ? ( language === 'es' ? 'Administrador' : 'Administrator' )
        //                         : params.value==='Aprobador'
        //                             ? ( language === 'es' ? 'Aprobador' : 'Reviewer' )
        //                             : params.value==='Artista'
        //                                 ? ( language === 'es' ? 'Artista' : 'Artist' )
        //                                 : ''
        //                 }
        //             </div>
        //         );
        //     }
        // },

        
        {   
            field: 'createdAt',
            description: t("userView.createdAt"),
            headerName: t("userView.createdAt"),
            type: 'string',
            width: 130,
            headerAlign: 'left',
        },
        {
            field: 'active',
            description: t("userView.active"),
            headerName: t("userView.active"),
            type: 'string',
            width: 130,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        {
                            params.value==='Activo' || params.value==='Active'
                                ? ( language === 'es' ? 'Activo' : 'Active' )
                                : ( language === 'es' ? 'Inactivo' : 'Inactive' )
                        }
                    </div>
                );
            }
        },
    ];


    const sch = (yup) => yup.object({
        name: yup.string().max(40),
        email: yup.string().max(40),
        roleId: yup.number(),
        active: yup.string()
    });
    const schema = useYupSchema(sch);


    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                name: '',
                email: '',
                roleId: roleId,
                active: active
            }
        });

    
    // LOCAL STATES
    
    
    // NEEDED HOOKS
    const dispatch = useDispatch();
    const { items: userList } = useSelector(state => state.userAdmin);
    const { language } = useSelector(state => state.configuration);
    
    // EFFECTS
    useEffect(() => {
        dispatch(
            load
            (
                {
                    userId: '-1',
                    name: '',
                    email: '',
                    active: active,
                    roleId: roleId.toString()
                }
            )
        )
    }, [])

    // LOCAL FUNCTIONS
    const onSubmit = (data) => {
        dispatch(
            load
            (
                {
                    userId: '-1',
                    name: data.name,
                    email: data.email,
                    active: active,
                    roleId: roleId.toString()
                }
            )
        )
    }

    const handleClickMenu = (id) => {
        dispatch(selectItem(id));
        dispatch(showUserViewProfile(true));
    };

    
    return(
        <>
            <BodyMain>
                <h2 style={{color:'#667'}}>{t("userView.title")}</h2>
                <form onSubmit={handleSubmit(onSubmit)}
                    style={{
                        width:'100%',
                        height:'100%',
                        display:'flex',
                        flexDirection:'column',
                        marginBottom:'50px'
                    }}
                >
                    <Grid container size={12} spacing={2}>
                        <Grid size={6}>
                            <TextField id="txtName" label={t("userView.name")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('name')}
                                error={!!errors.name}
                                helperText={errors.name?.message}
                            />
                        </Grid>
                        <Grid size={6}>
                            <TextField id="txtEmail" label={t("userView.email")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('email')}
                                error={!!errors.email}
                                helperText={errors.email?.message}
                            />
                        </Grid>
                    </Grid>
                    <Grid container size={12} spacing={2}>
                        <Button
                            type="submit"
                            variant="outlined"
                            sx={{ ...constants.styles.mainButton, width: 'auto-fit', paddingLeft:'80px', paddingRight:'80px' }}
                        >
                            {t("userView.search")}
                        </Button>
                    </Grid>
                </form>
                <Box sx={{ 
                    width: '100%',
                    '& .alternateClass': {
                        backgroundColor: '#f2f2f2',
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .rowClass': {
                        borderTop: '1px solid #e8e8e8',
                    },
                    '& .alternateClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                    '& .rowClass:hover': {
                        backgroundColor: '#999c9e',
                    },
                }}>
                    <DataGrid
                        getRowId={(row) => row.userId}
                        getRowHeight={() => 40}
                        rows={userList || []}
                        columns={columsGrid}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            density: 'compact',
                        }}
                        // paginationModel={{ page: 0, pageSize: 100 }} // Muestra todas las filas
                        // pageSizeOptions={[]} // Oculta el selector de páginas
                        // hideFooter
                        getRowClassName ={
                            (params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'alternateClass' : 'rowClass'
                        }
                        pageSizeOptions={[5,10,20,{value:-1, label:language==='es' ? 'Todo' : 'All'}]}
                        checkboxSelection = {false}
                        disableRowSelectionOnClick
                        disableColumnMenu
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                            }
                        }}
                        localeText={
                            language === 'es' 
                            ? esES.components.MuiDataGrid.defaultProps.localeText
                            : enUS.components.MuiDataGrid.defaultProps.localeText
                        }
                        sx={{
                            '& .MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                                color: '#667', 
                                fontSize: '0.8rem',
                            },
                        }}
                    />
                </Box>
                <br /><br />
            </BodyMain>

            <UsersViewProfile />
        </>
    )
}

export default UsersView;